import { z } from 'zod';

export const billingUsageSummarySchema = z.object({
  id: z.string(),
  companyId: z.string(),
  cycleStart: z.string().datetime(),
  cycleEnd: z.string().datetime(),
  includedIncrements: z.number().int(),
  usedIncrements: z.number().int(),
  overageIncrements: z.number().int(),
  pushedToGhlAt: z.string().datetime().nullable(),
  ghlInvoiceLineId: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type BillingUsageSummary = z.infer<typeof billingUsageSummarySchema>;
